import { render } from "./FranchiseLoyaltyConfig.vue?vue&type=template&id=0632a39a&scoped=true&ts=true"
import script from "./FranchiseLoyaltyConfig.vue?vue&type=script&lang=ts"
export * from "./FranchiseLoyaltyConfig.vue?vue&type=script&lang=ts"

import "./FranchiseLoyaltyConfig.vue?vue&type=style&index=0&id=0632a39a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0632a39a"]])

export default __exports__